import { render, staticRenderFns } from "./inquiryInfo.vue?vue&type=template&id=5da344ac"
import script from "./inquiryInfo.vue?vue&type=script&lang=js"
export * from "./inquiryInfo.vue?vue&type=script&lang=js"
import style0 from "./inquiryInfo.vue?vue&type=style&index=0&id=5da344ac&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da344ac')) {
      api.createRecord('5da344ac', component.options)
    } else {
      api.reload('5da344ac', component.options)
    }
    module.hot.accept("./inquiryInfo.vue?vue&type=template&id=5da344ac", function () {
      api.rerender('5da344ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/inquiry/inquiryInfo.vue"
export default component.exports